import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Icon from 'Components/Atoms/Icon/Icon';
import Checkbox from 'Components/Atoms/Checkbox/Checkbox';
import Tooltip from 'Components/Molecules/Tooltip/Tooltip';
import InvoiceAmount from 'Components/Molecules/InvoiceAmount/InvoiceAmount';
import ForecastValueStatusBadge from './ForecastValueStatusBadge';
import { INVOICES_RECONCILED_STATUS } from 'Utils/constants';
import { cn } from 'Utils/cn';

export default function ForecastValueInvoiceRow(props) {
    const { invoice, selectable = false, checked = false, disabled = false, onCheckedChange, onOpen } = props;

    const { t } = useTranslation('calendar');

    const isReconciled = invoice.reconciled_status === INVOICES_RECONCILED_STATUS.RECONCILED;

    return (
        <div className="px-5 py-3 not-last:border-b border-gray-200">
            <div className={cn('flex items-center gap-3', disabled && 'opacity-50 pointer-events-none')}>
                {selectable ? (
                    <Checkbox checked={checked} onChange={(ev) => onCheckedChange(ev.target.checked)} />
                ) : (
                    <span className="w-5 shrink-0" aria-hidden="true" />
                )}

                <div className="grid grid-cols-[1fr_auto_32px] sm:grid-cols-[3fr_1fr_110px_32px] gap-3 grow items-center min-w-0 text-sm">
                    <div className="flex items-center gap-2 min-w-0">
                        <span className="truncate">{invoice.invoice_party_display_name ?? '-'}</span>
                        <ForecastValueStatusBadge isCompleted={isReconciled} />
                    </div>

                    <div className="text-gray-500 text-xs truncate hidden sm:block">{invoice.identifier}</div>

                    <InvoiceAmount invoice={invoice} />

                    <div className="flex relative">
                        <Tooltip label={t(isReconciled ? 'view-invoice-reconciled' : 'view-invoice')}>
                            <button className="inline-flex relative" type="button" onClick={() => onOpen(invoice)}>
                                <Icon name="nav-invoices" className="w-6 block shrink-0" />
                            </button>
                        </Tooltip>

                        {invoice.recurrence_to_invoices?.length > 0 && (
                            <Tooltip label={t('recurrence')}>
                                <span className="absolute top-1/2 left-full -translate-y-1/2 -translate-x-1">
                                    <Icon name="rotate-ccw" color="#919191" size={16} />
                                </span>
                            </Tooltip>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

ForecastValueInvoiceRow.propTypes = {
    invoice: PropTypes.object.isRequired,
    onOpen: PropTypes.func.isRequired,
    selectable: PropTypes.bool,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onCheckedChange: PropTypes.func,
};
